import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "required", "value"]


const __default__ = {
  inheritAttrs: false
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Input',
  props: {
    id: {},
    label: {},
    optional: { type: Boolean },
    marginless: { type: Boolean },
    modelValue: {},
    showLabel: { type: Boolean },
    focus: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.marginless ? '' : 'mb-2'])
  }, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass([_ctx.showLabel ? 'label' : 'sr-only'])
    }, _toDisplayString(_ctx.label), 11, _hoisted_1),
    _withDirectives(_createElementVNode("input", _mergeProps({
      id: _ctx.id,
      required: !_ctx.optional,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, _ctx.$attrs), null, 16, _hoisted_2), [
      [_directive_focus, _ctx.focus || false]
    ])
  ], 2))
}
}

})